import { Box, Grid } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { captureMessage } from 'sentry';
import { ROUTES } from 'shared/constants/ROUTES';
import { useStyles } from './ProfileSelection.styles';

const ProfileSelection: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  // useEffect(() => {
  //   captureMessage('user landed on registration page');
  // }, []);

  return (
    <>
      <Grid item>
        <Typography className={classes.heading}>Please let us know which type of profile fits you better</Typography>
      </Grid>
      <Grid item className={classes.selectionContainer}>
        <Box
          component="div"
          // className={`${classes.box} ${profileType === 'adult' ? classes.boxActive : ''}`}
          className={`${classes.box}  ${classes.boxActive}`}
          onClick={() => history.push(`${ROUTES.REGISTRATION}/adult`)}
          // onClick={() => logEvent('user clicke on adult profile')}
        >
          <Typography fontSize={24}>Adult Profile</Typography>
          <Typography fontSize={18} className={classes.helpText} style={{ marginTop: 2 }}>
            18 Years+
          </Typography>
          <Typography color="primary" style={{ marginTop: 5 }} className={classes.primaryText}>
            I am an individual adult talent
          </Typography>
        </Box>
        <Box
          component="div"
          // className={`${classes.box} ${profileType === 'minor' ? classes.boxActive : ''}`}
          className={`${classes.box}  ${classes.boxActive}`}
          onClick={() => history.push(`${ROUTES.REGISTRATION}/minor/guardian_info`)}
        >
          {/* <Typography fontSize={24}>Minor Profile</Typography> */}
          <Typography fontSize={24}>Guardian/Parent</Typography>
          <Typography fontSize={18} style={{ marginTop: -5 }}>
            (Minor or Family Profile)
          </Typography>
          <Typography fontSize={18} className={classes.helpText} style={{ marginTop: 2 }}>
            Under 18 Years
          </Typography>
          <Typography color="primary" style={{ marginTop: 5 }} className={classes.primaryText}>
            {/* I am the parent/guardian adding one or multiple child talent */}
            Click here to add minor and/or family profile
          </Typography>
        </Box>
      </Grid>
    </>
  );
};

export default ProfileSelection;
